import { render, staticRenderFns } from "./PostSmallBlock.vue?vue&type=template&id=72cd5f86&v-slot=color&"
import script from "./PostSmallBlock.vue?vue&type=script&lang=js&"
export * from "./PostSmallBlock.vue?vue&type=script&lang=js&"
import style0 from "./PostSmallBlock.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports